import { INCLUSO_WEBSITE_URL } from "~/content/value";
import { env } from "~/env";

export const matchEmail = (s: string) =>
  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/.test(s);

export const removeQueryString = (s: string) => s.split("?")[0];

export const validateEmail = (
  email: string | undefined,
): string | undefined => {
  if (!email) return "Email is required.";

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email.trim()) {
    return "Email is required.";
  } else if (!emailRegex.test(email)) {
    return "Invalid email format.";
  }
  return undefined;
};

export const validatePhone = (
  phone: string | undefined,
): string | undefined => {
  if (!phone) return "Phone is required.";

  const nospace = phone.replace(/\s+/g, "");
  if (!nospace) return "Phone is required.";
  if (nospace.length < 8) return "Phone number is not long enough.";
  if (!/^\d+$/.test(nospace)) return "Invalid phone number format.";

  return undefined;
};

export function formatDate(s: string): string {
  const date = new Date(s);
  return date.toLocaleDateString("en-AU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export const noBreakStr = (s?: string) => s?.replaceAll(" ", `\xa0`);

export function absoluteUrl(s: string) {
  return `${env.NEXT_PUBLIC_DRUPAL_BASE_URL ?? "https://drupal-development.incluso.com.au"}${s}`;
}
